import React, { useMemo } from 'react';
import { STDStyle, Buttons } from '../../style';
import Std from '../../../stdPages/std';
import Text from '@/components/Text';
import * as w from '@/helpers_site/textsSite';
import Button from '@/components/Button';
import ButtonBack from '@/components/ButtonBack';
import axios from 'axios';
import { useStepGate } from '../usetStepGate';


import { useSearchParams, useNavigate } from 'react-router-dom';
import { QRCodeSVG } from 'qrcode.react';

const QrCode = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const rid = new URLSearchParams(window.location.search).get("rid") || "";
  const { loading, allowed } = useStepGate(`${process.env.API_BASE_PATH}/auth/status/qrcode-status?rid=${encodeURIComponent(rid)}`);

  const qrValue = useMemo(() => {
    if (!rid) return '';
    // Para teste: só o rid
    // Depois você pode trocar por deep link do app:
    // return `auroraself://login?rid=${encodeURIComponent(rid)}`;
    return rid;
  }, [rid]);

  
  if (loading || !allowed) return null;

  if (!rid) {
    // Se não vier rid, você pode jogar para 404 ou iniciar fluxo de novo
    return (
      <Std id='front' withoutMenu={true}>
        <STDStyle>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            <Text title={'QR Code'} $family='head' color={'rgb(0,14,38)'} typeFont='head' tag='h2' />
            <Text title={'RID ausente. Reinicie o login.'} $family='text' color={'rgb(0,14,38)'} typeFont='text' tag='p' />
            <button onClick={() => navigate('/')}>Voltar</button>
          </div>
        </STDStyle>
      </Std>
    );
  }

  return (
    <Std id='front' withoutMenu={true}>
      <STDStyle>
        <div style={{ display: 'flex', flexDirection: 'column', gap:'24px', alignItems: 'center' }}>
          <Text title={'QRCode'} $family='head' color={'rgb(0,14,38)'} typeFont='head' tag='h2' />

          <QRCodeSVG
            value={qrValue}
            size={240}
            includeMargin={true}
          />

          <div style={{ maxWidth: 520, textAlign: 'center' }}>
            <Text
              title={'Abra o app e escaneie o QR Code para aprovar o login.'}
              $family='text'
              color={'rgb(0,14,38)'}
              typeFont='text'
              tag='p'
            />
            <Text
              title={`RID: ${rid}`}
              $family='text'
              color={'rgb(0,14,38)'}
              typeFont='text'
              tag='p'
            />
          </div>
        </div>
      </STDStyle>
    </Std>
  );
};

export default QrCode;
